import { Section, Eyebrow, Heading, P, PullQuote } from "../Chapter";

export const Gained = () => (
    <Section className="bg-surface">
        <Eyebrow>VI. The gift</Eyebrow>
        <Heading>What this gave us</Heading>

        <P>It would be dishonest to tell this story only as a loss.</P>
        <P delay={0.05}>
            Distance stopped charging rent. A person in a small town can reach anyone on earth, in
            seconds, for effectively nothing. That is not a minor thing — it is arguably the largest
            expansion of access in human history, and it happened inside a single lifetime.
        </P>
        <P delay={0.05}>
            Families split by oceans eat dinner together on a screen. A grandmother sees a
            grandchild she will never hold. Someone with a rare illness finds eleven other people
            who have it. A student with no library learns from the best teacher in the world, free,
            at two in the morning.
        </P>

        <PullQuote>
            The old world was slower, but it was also smaller, and it kept most people out.
        </PullQuote>

        <P>
            The letters in the tin box are beautiful. They were also written by the few people who
            could write, sent through a system most people couldn't afford, to places most people
            would never go — and often written by a scribe, because the sender had no other way.
            Speed democratized the sentence. Anyone who romanticizes the past should be honest about
            who was allowed into it.
        </P>
    </Section>
);
